export default "* Smykke\n* Hyldetræ\n* Overtro";